import React, { useId } from 'react';
import { InputNumber } from 'primereact/inputnumber';
import { StyledPrimeReactInput } from 'styles/v2/Styles.styled';
import useIsReadOnlyMode from '../compiler/hooks/useIsReadOnlyMode';
import SmartLabel, { TSmartLabelProps } from '../labels/SmartLabel';

type Props = Partial<TSmartLabelProps> & {
  name: string;
  value: number | null;
  onChange(propertyName: string, newValue: number | null): void;
  disabled?: boolean;
  placeholder?: string;
  id?: string;
  maxFractionDigits?: number;
};

const WizardNumberInputControlled: React.FC<Props> = ({
  name,
  value,
  onChange,
  label,
  required,
  labelStyle,
  tooltip,
  tooltipPosition,
  error,
  placeholder,
  id,
  disabled,
  maxFractionDigits = 2,
}) => {
  const fallbackInputId = useId();
  const inputId = id || fallbackInputId;
  const isReadOnly = useIsReadOnlyMode() || disabled;

  return (
    <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
      {label && (
        <SmartLabel
          label={label}
          required={required}
          labelStyle={labelStyle}
          tooltip={tooltip}
          tooltipPosition={tooltipPosition}
          error={error}
          hasValue={value !== null}
        />
      )}
      <StyledPrimeReactInput
        as={InputNumber}
        inputId={inputId}
        value={value}
        onValueChange={(e) => onChange(name, e.value ?? null)}
        disabled={isReadOnly}
        placeholder={isReadOnly ? undefined : placeholder}
        useGrouping={false}
        maxFractionDigits={maxFractionDigits}
      />
    </div>
  );
};

export default WizardNumberInputControlled;
